import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type RunningIconProps = Partial<SVGIconProps>;

/** Activity icon copied from the mobile Exercise revamp pack. */
const RunningIcon: FC<RunningIconProps> = (props) => (
  <SVGIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 4.5C17 4.89782 16.842 5.27936 16.5607 5.56066C16.2794 5.84196 15.8978 6 15.5 6C15.1022 6 14.7206 5.84196 14.4393 5.56066C14.158 5.27936 14 4.89782 14 4.5C14 4.10218 14.158 3.72064 14.4393 3.43934C14.7206 3.15804 15.1022 3 15.5 3C15.8978 3 16.2794 3.15804 16.5607 3.43934C16.842 3.72064 17 4.10218 17 4.5Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M15 21L14.336 18.385C14.1152 17.5164 13.6603 16.725 13.021 16.097L11.5 14.6M11.5 14.6C10.493 13.806 9.988 13.409 9.793 12.878C9.70594 12.6419 9.66421 12.3915 9.67 12.14C9.684 11.574 10.033 11.036 10.73 9.95999L12 8.00099M11.5 14.6L15 9.27699M20 8.19999C17.963 10.492 16.155 10.143 15 9.27699M15 9.27699C14.8703 9.17273 14.7523 9.05471 14.648 8.92499C14.236 8.43299 14.029 8.18599 13.828 8.09199C13.627 7.99799 13.375 7.99799 12.87 7.99799C12.544 7.99799 12.219 7.99799 12 8.00099M12 8.00099C8.538 8.04199 7 9.18399 6 11.153M4 17.73L4.678 17.892C6.407 18.302 8.203 17.516 9 16"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </SVGIcon>
);

export default RunningIcon;
